export const buildPayoutsFilterGroups = (filterOptions = {}) => [
  {
    id: 'source',
    label: 'Source',
    filters: [
      {
        id: 'source',
        label: 'Source',
        type: 'checkbox',
        options: (filterOptions.source_options || [
          { value: 'dos', label: 'DOS' },
          { value: 'advance', label: 'Advance' },
          { value: 'distribution', label: 'Opendate Distribution' },
        ]).map(o => ({ value: String(o.value), label: o.label })),
      },
    ],
  },
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({
          value: String(o.value),
          label: o.label,
        })),
      },
    ],
  },
  {
    id: 'payout_status',
    label: 'Payout Status',
    filters: [
      {
        id: 'payout_scope',
        label: 'Eligibility',
        type: 'checkbox',
        options: [
          { value: 'eligible', label: 'Eligible for next payout only' },
        ],
      },
    ],
  },
];
